import React from 'react';
import * as helpers from "./Helpers";
import Item from "./Item";
import PropTypes from 'prop-types';
import { observer, propTypes as mobxPropTypes } from 'mobx-react';

const Results = ({
  blue,
  isOpen,
  items,
  itemToString,
  renderItem,
  getItemProps,
  highlightedIndex,
  selectedItem,
  loading = false,
  creatable = false,
  itemFromCreatable,
  inputValue,
  showResultsOnEmptyInput,
  showAllItemsOnEmpty = false
}) => {
  if (!isOpen) return null;
  if (creatable && !(inputValue && inputValue.trim())) return null;

  if (!inputValue && !showResultsOnEmptyInput) {
    return /*#__PURE__*/React.createElement("div", null, "Type to search");
  }

  if (loading && (items === null || items === void 0 ? void 0 : items.length) === 0 && !creatable) {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }

  if ((items === null || items === void 0 ? void 0 : items.length) === 0 && !creatable && !showResultsOnEmptyInput) {
    return /*#__PURE__*/React.createElement("div", null, "No results...");
  }

  const creatableItem = creatable && createCreatableItem({
    items,
    itemFromCreatable,
    inputValue,
    itemToString,
    selectedItem
  });
  const resultItems = creatableItem ? [creatableItem, ...items] : items;
  return /*#__PURE__*/React.createElement("div", {
    className: `autocomplete__results-container${blue ? ' autocomplete__results-container--blue' : ''}`
  }, resultItems.map((item, index) => {
    const isActive = highlightedIndex === index;
    const isSelected = helpers.isSelected({
      selectedItem,
      item,
      itemToString
    });
    return /*#__PURE__*/React.createElement(Item, getItemProps({
      item,
      disabled: isSelected || item.disabled,
      key: helpers.getKey(itemToString, item),
      isActive,
      isSelected: isSelected,
      onClick: stopEventPropagation
    }), helpers.renderItem({
      renderItem,
      itemToString,
      item
    }));
  }));
};

Results.propTypes = {
  blue: PropTypes.bool,
  creatable: PropTypes.bool,
  getItemProps: PropTypes.func.isRequired,
  highlightedIndex: PropTypes.number,
  inputValue: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  itemFromCreatable: PropTypes.func,
  items: PropTypes.oneOfType([PropTypes.array, mobxPropTypes.observableArray]).isRequired,
  itemToString: PropTypes.func,
  loading: PropTypes.bool,
  renderItem: PropTypes.func,
  selectedItem: PropTypes.any,
  showResultsOnEmptyInput: PropTypes.bool
};
Results.defaultProps = {
  itemFromCreatable: inputValue => inputValue,
  highlightedIndex: null
};

function createCreatableItem({
  items,
  itemFromCreatable = item => item,
  inputValue,
  itemToString,
  selectedItem
}) {
  const existingItemAlreadySelected = selectedItem && itemToString(selectedItem) === inputValue;
  if (existingItemAlreadySelected) return null;
  const doesCreatableOptionExistAmongItems = items.map(item => itemToString(item).toLowerCase()).includes(inputValue.trim().toLowerCase());
  if (doesCreatableOptionExistAmongItems) return null;
  return itemFromCreatable(inputValue);
}

export default observer(Results);

function stopEventPropagation(event) {
  return event.stopPropagation();
}